import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import Default from 'components/Input/Default';

/**
 * Input with postfix symbol
 * @param {String} type - Type of the input (email, tel, text, number,...)
 * @param {Object} input - Redux form input
 * @param {String} placeholder - Placeholder of the input
 * @param {number} min - Minimum value of the input if type number
 * @param {String} postfixSymbol - Symbol of the input
 */
const Postfix = ({ postfixSymbol, small, ...rest }) => {
    const wrapperClasses = classnames('field--postfix', {
        'field--small': small,
    });

    const fieldPostfixClasses = classnames('field__postfix', {
        'field__postfix--small': small,
    });

    return (
        <Default {...rest} wrapperClassName={wrapperClasses}>
            <span className={fieldPostfixClasses}>{postfixSymbol}</span>
        </Default>
    );
};

Postfix.propTypes = {
    postfixSymbol: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    small: PropTypes.bool,
};

Postfix.defaultProps = {
    small: false,
};

/**
 * Postfix Functionnal Component
 */
export default Postfix;
